// Module
var code = "{{# if (!data.status.isSelected && !data.status.isPreselected) { }} {{# if (data.status.isTopChoice) { }} <span class=\"odf-icon odf-icon-l odf-icon-star odf-pr-sm odf-inline-middle\"></span> {{# } }} <span class=\"marker_price odf-strong odf-inline-middle odf-text-condensed\"> {{ data.marker.tooltipPrice }} </span> {{# } }} ";
// Exports
module.exports = code;